export * from './new-consigna-dialog.component';
export * from './repetir-subdialog.component';


// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agenda/new-consigna-dialog/index.ts